import axios from 'axios';
import { API_URL } from '../config';

const ax = axios.create();

export const fetchContractPdf = (type, token) => {
  const URL = `${API_URL}/contract-by-token/${type}/${token}`;
  return axios(URL, {
    method: 'GET',
  }).then((response) => response.data);
};

export const sendPDFSToEmails = (id, data) => {
  const URL = `${API_URL}/pdf/${id}/send`;
  return axios.post(URL, data).then((response) => response.data);
};

export const getRecurringPaymentsSummary = (data) => {
  const URL = `${API_URL}/pdf/validation`;
  return ax.post(URL, data).then((response) => response.data);
};
